import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { api } from "@/lib/api";

export default function FounderStoryAdmin() {
  const [text, setText] = useState("");
  const [isDefault, setIsDefault] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/site/founder-story").then((r) => { setText(r.data.text || ""); setIsDefault(r.data.is_default); });
  }, []);

  const save = async () => {
    setBusy(true);
    try {
      const r = await api.put("/admin/founder-story", { text });
      setText(r.data.text);
      setIsDefault(false);
      toast.success("Founder story saved on /about.");
    } catch {
      toast.error("Could not save — keep it under 3,000 characters.");
    } finally {
      setBusy(false);
    }
  };

  const reset = async () => {
    const r = await api.delete("/admin/founder-story");
    setText(r.data.text);
    setIsDefault(true);
    toast.success("Starter draft restored.");
  };

  return (
    <section className="border border-obsidian-600 p-6 mb-8" data-testid="founder-story-admin">
      <h2 className="font-serif text-2xl text-bone-100 mb-2">"Why I built Umbra" (/about)</h2>
      <p className="font-sans text-sm text-bone-400 mb-4">
        First-person, in your words. Blank line = new paragraph. Leave empty to hide the section.
        {isDefault && <span className="text-terracotta" data-testid="founder-story-default-note"> Showing the starter draft — edit and save to make it yours.</span>}
      </p>
      <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={8} maxLength={3000}
        className="bg-obsidian-800 border-obsidian-600 rounded-none text-bone-100" data-testid="founder-story-input" />
      <Button onClick={save} disabled={busy} data-testid="founder-story-save"
        className="mt-3 rounded-none bg-terracotta hover:bg-terracotta-deep text-obsidian-900 uppercase tracking-wider text-xs">
        Save story
      </Button>
      {!isDefault && (
        <Button onClick={reset} data-testid="founder-story-reset"
          className="mt-3 ml-3 rounded-none bg-transparent border border-obsidian-600 text-bone-400 hover:text-terracotta hover:bg-transparent uppercase tracking-wider text-xs">
          Reset to starter draft
        </Button>
      )}
    </section>
  );
}
